import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DescriptionComponent } from './description/description.component';
import { HomeComponent } from './home/home.component';
//import { ContactFormComponent } from './contact-form/contact-form.component';
import { Nl2BrPipeModule } from 'nl2br-pipe';
 
//import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,	
    HeaderComponent,
    FooterComponent,
    DescriptionComponent,
    HomeComponent    
  ],
  imports: [
    BrowserModule,
	FormsModule,
	Nl2BrPipeModule,
	HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
